/**
 * The one background-refresh cadence, for every screen that polls.
 *
 * Polling exists because enquiry state is DERIVED BY THE SERVER — the backend moves status on
 * its own (`Items Matched`, `RFQ Sent`, `Quoted`, won/lost; see the four `setStatus` calls in
 * `mock-server/`). When THIS browser causes the transition its mutation already invalidates and
 * the screen updates; the gap is transitions caused by someone or something ELSE — a supplier's
 * quote landing, a colleague sending the quotation, a background job. The value changes with no
 * request from this tab and no response to attach it to, so the browser cannot know.
 *
 * There are exactly two ways to learn about it: be pushed (a socket) or re-read (a poll). The
 * mock emits NO socket events (`useRealtime.ts`'s header; `mock-server/` has no socket
 * dependency) and the live payload shapes are still an open ask to the Frappe team (Q13). So
 * re-reading is the only mechanism that works against both backends today. Realtime, where it
 * works, shortens the wait on top of this — it never replaces it.
 *
 * This was three separate `30_000` declarations before (`MAIL_POLL_MS`, `SQ_POLL_MS`,
 * `BOARD_POLL_MS`) and was about to become six. Each of those names survives as an alias, so
 * call sites read the same, but the cadence is now one decision.
 *
 * Note the asymmetry with `staleTime` if you are tuning this: `refetchInterval` IGNORES
 * `staleTime`, which is why only the volatile hooks get one and the masters
 * (`useUoms`, `useMasters`, `useSettings`, `attachmentBlob`) get none.
 */
export const POLL_MS = 30_000
